var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SiteLogo } from './site-logo';
import { SliceLayoutBoundary } from '../entities/slice-layout';
import { classNames } from '@shapeable/utils';
import { useSite } from '../hooks/use-site';
import { Icon } from '../elements/icon';
import { useSiteSidebar } from '../hooks/use-site-sidebar';
import { useModal } from '../hooks/use-modal';
import { useSiteMenuBar } from '../hooks/use-site-menu-bar';
import { CrossIcon } from '@shapeable/icons';
import { EntityValue } from './entity-value';
import { useIsDarkColor } from '../hooks/use-is-dark-color';
import { ThemeModeProvider } from '../context/theme-mode-context';
import { useComponentPropsFor } from '../context/component-props-context';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
import { useThemeEval } from '../hooks/use-theme-eval';
import { Helmet } from 'react-helmet';
var cls = classNames('site-menu-bar');
export var SiteMenuBarDefaultProps = {
  colors: {
    background: 'bright'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    width: 100%;\n    display: flex;\n    min-width: 320px;\n    align-items: center;\n    ", "\n  "], ["\n    ", ";\n    width: 100%;\n    display: flex;\n    min-width: 320px;\n    align-items: center;\n    ", "\n  "])), theme.APPLY_COLORS, function (_a) {
    var _height = _a._height;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), _height);
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    ", "\n  "], ["\n    width: 100%;\n    ", "\n  "])), function (_a) {
    var sidebarWidth = _a.sidebarWidth;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: calc(100% - ", "px);\n    "], ["\n      width: calc(100% - ", "px);\n    "])), sidebarWidth);
  }),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n    ", "\n  "], ["\n    width: 100%;\n    ", "\n  "])), function (_a) {
    var sidebarWidth = _a.sidebarWidth;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: calc(100% - ", "px);\n    "], ["\n      width: calc(100% - ", "px);\n    "])), sidebarWidth);
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
var LogoStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: relative;\n    flex-shrink: 0;\n\n    ", "\n\n    img {\n      height: 100%;\n    }\n\n  "], ["\n    position: relative;\n    flex-shrink: 0;\n\n    ", "\n\n    img {\n      height: 100%;\n    }\n\n  "])), function (_a) {
    var _height = _a._height,
      horizontalOffset = _a.horizontalOffset,
      verticalOffset = _a.verticalOffset;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "], ["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "])), _height, horizontalOffset, verticalOffset);
  })
});
var ControlsStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "]))),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  desktop: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var MenuButtonsStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  desktop: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: none;\n    align-items: center;\n  "], ["\n    display: none;\n    align-items: center;\n  "])))
});
var UtilityButtonsStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: none;\n    align-items: center;\n  "], ["\n    display: none;\n    align-items: center;\n  "]))),
  desktop: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var CloseButtonStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
var StartStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-shrink: 1;\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-shrink: 1;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    fex-shrink: 1;\n    margin: 0 ", " 0 ", ";\n    display: none;\n    color: ", ";\n    white-space: nowrap;\n    max-width: 400px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  \n    .shp--entity-value {\n      overflow: hidden;\n    }\n\n    .shp--entity-value__label-and-name {\n      overflow: hidden;\n    }\n\n    .shp--entity-value__name { \n      display: block;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      width: 100%;\n    }   \n\n\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    fex-shrink: 1;\n    margin: 0 ", " 0 ", ";\n    display: none;\n    color: ", ";\n    white-space: nowrap;\n    max-width: 400px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  \n    .shp--entity-value {\n      overflow: hidden;\n    }\n\n    .shp--entity-value__label-and-name {\n      overflow: hidden;\n    }\n\n    .shp--entity-value__name { \n      display: block;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      width: 100%;\n    }   \n\n\n  "])), theme.FONT_SIZE(16), theme.UNIT(4), theme.UNIT(5), theme.COLOR('light')),
  tablet: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SiteMenuBar',
  Container: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Start: styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  Logo: styled(SiteLogo)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  Title: styled.h1.attrs(cls.attr('title'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Controls: styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  UtilityButtons: styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), UtilityButtonsStyles),
  MenuButtons: styled.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonsStyles),
  Buttons: styled.div(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  CloseButton: styled(Icon)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles)
};
export var SiteMenuBar = function (props) {
  var _a = useComponentPropsFor(My.NAME, SiteMenuBarDefaultProps, props),
    className = _a.className,
    buttons = _a.buttons,
    utilityButtons = _a.utilityButtons,
    entity = _a.entity,
    menuButtons = _a.menuButtons,
    title = _a.title,
    children = _a.children,
    onCloseClick = _a.onCloseClick,
    colors = _a.colors,
    themeMode = _a.themeMode;
  var modal = useModal();
  var showButtons = !modal.isVisible; /* && !map.isVisible */
  var showCloseButton = props.showCloseButton || modal.isVisible;
  var _b = useSite(),
    headerHeightMobile = _b.headerHeightMobile,
    logoHorizontalOffset = _b.logoHorizontalOffset,
    logoVerticalOffset = _b.logoVerticalOffset,
    logoHorizontalOffsetMobile = _b.logoHorizontalOffsetMobile,
    logoVerticalOffsetMobile = _b.logoVerticalOffsetMobile,
    logoHeightMobile = _b.logoHeightMobile;
  var menuBar = useSiteMenuBar();
  var activeThemeMode = useActiveThemeMode();
  var isInverted = themeMode === 'dark' || useIsDarkColor({
    colors: colors,
    key: 'background'
  });
  var newThemeMode = isInverted ? 'dark' : activeThemeMode === null || activeThemeMode === void 0 ? void 0 : activeThemeMode.themeMode;
  var sidebar = useSiteSidebar();
  var $ = useThemeEval();
  var backgroundColor = $(theme.COLOR(colors.background));
  var onCloseClickHandler = onCloseClick || function () {
    return modal.hide();
  };
  return React.createElement(My.Container, {
    sidebarWidth: sidebar.isAvailable() && sidebar.width,
    _height: headerHeightMobile,
    colors: colors,
    className: cls.name(className)
  }, backgroundColor && React.createElement(Helmet, null, React.createElement("meta", {
    name: "theme-color",
    content: backgroundColor
  })), React.createElement(ThemeModeProvider, {
    value: newThemeMode
  }, React.createElement(SliceLayoutBoundary, {
    boundary: props.boundary || menuBar.boundary
  }, React.createElement(My.Body, null, React.createElement(My.Start, null, React.createElement(My.Logo, {
    horizontalOffset: logoHorizontalOffsetMobile || logoHorizontalOffset,
    verticalOffset: logoVerticalOffsetMobile || logoVerticalOffset,
    variant: isInverted ? 'inverted' : 'default',
    _height: logoHeightMobile
  }), React.createElement(My.Title, null, modal.isVisible && modal.title || entity && React.createElement(EntityValue, {
    variant: 'name',
    entity: entity
  }) || title)), React.createElement(My.Controls, null, showButtons && React.createElement(React.Fragment, null, React.createElement(My.UtilityButtons, null, utilityButtons), React.createElement(My.MenuButtons, null, menuButtons), React.createElement(My.Buttons, null, buttons)), showCloseButton && React.createElement(My.CloseButton, {
    onClick: onCloseClickHandler,
    size: 32
  }, React.createElement(CrossIcon, null)))))));
};
SiteMenuBar.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;